<template>
  <div class="common-table" v-loading="loading">
    <div id="table-box-head" ref="table-box-head">
      <slot name="table_head"></slot>
    </div>
    <div class="null-box" v-if="!tableList || tableList.length === 0" :style="{'height':(height) + 'px'}">
      <nothing v-if="!loading" :config="config.nothing || {}" @button-click="$emit('button-click')"></nothing>
    </div>
    <div class="multipleTable-box" v-else>
      <el-table ref="multipleTable" :stripe="stripe" :data="tableList" size="small" :height="height || '100%'" style="width: 100%" @selection-change="handleSelectionChange" :highlight-current-row="true" :fit="true" :show-summary="showSummary" :summary-method="getSummaries" :default-sort="defaultSort" cell-class-name="cell-style" :row-class-name="rowClassName" :load="load" :lazy="lazy" :row-key="rowKey" :tree-props="treeProps" @row-click="singleElection" :row-style="rowStyle">
        <el-table-column type="selection" v-if="selection">
        </el-table-column>
        <el-table-column type="expand" v-if="expand">
          <slot name="expand">
          </slot>
        </el-table-column>
        <el-table-column width="40" type="single" v-if="single">
          <template slot-scope="scope">
            <div class="single-style">
              <el-radio class="radio" v-model="parentDepartmentList" :label="scope.$index">&nbsp;</el-radio>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="(item,index) in head" :fixed="item.fixed || false" :key="index" :type="item.type" :prop="item.key" :label="item.name" :width="item.width" align="left" :show-overflow-tooltip="false" :sortable="item.sortable">
          <template slot="header">
            {{item.name}}
            <el-tooltip v-if="item.tip" class="item" effect="dark" :content="item.tip" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="cell-table-item" :class="{'color-type-check':item.check && config.setCellStyle && config.setCellStyle(scope.row)}" :key="createUniqueId(1)[0]">
              <span class="cell-table-item--box">
                <toolTip style="width: 100%;" :title="getValueByPath(scope.row,item.key)">
                  <slot :name="item.key" :data="scope.row" :index="scope.$index">
                    {{getValueByPath(scope.row,item.key)}}
                  </slot>
                </toolTip>
              </span>
              <!-- <toolTip style="width: 100%;" :title="getKeyList(scope.row,item.key)" v-else>
                <slot :name="item.key" :data="scope.row" :index="scope.$index">
                  {{getKeyList(scope.row,item.key)}}
                </slot>
              </toolTip> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="verifyRemark" :width="verifyWidth">
          <template slot-scope="scope">
            <el-popover placement="left-start" :ref="'autoPopover_' + scope.$index" trigger="click" transition="el-zoom-in-center" popper-class="table-popover" v-if="popover" @click.native.stop @show="showPopover(scope.$index)">
              <div class="btns-popover">
                <slot name="verifyRemark" class="popover-btn" :data="scope.row" :index="scope.$index"></slot>
              </div>
              <p slot="reference" class="autoClicks">
                <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
              </p>
            </el-popover>
            <div class="verifyRemark-style" v-else>
              <slot name="verifyRemark" :data="scope.row" :index="scope.$index"></slot>
            </div>
          </template>
          <template slot="header">
            <slot name="header">
              <span>操作</span>
            </slot>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination-block" v-if="needPage && tableList && tableList.length > 0">
      <el-pagination style="float:right" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="ruleForm.pagData.page" :page-sizes="ruleForm.pagData.pageSizes" :page-size="ruleForm.pagData.number" :layout="ruleForm.pagData.layout" :total="ruleForm.pagData.total" hide-on-single-page>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
export default {
  props: {
    params: { // 表格请求参数
      type: Object,
      default: () => { }
    },
    tableHead: { // 表头
      type: String,
      default: ''
    },
    apiUrl: { // 表格请求连接
      type: Object,
      default: () => { }
    },
    showSummary: { // 是否展示统计
      type: Boolean,
      default: () => false
    },
    selection: { // 多选框
      type: Boolean,
      default: () => false
    },
    expand: { // 自定义列
      type: Boolean,
      default: () => false
    },
    dataset: { // 手动传递的数据
      type: Array,
      default: () => []
    },
    isSelfMak: { // 是否为手动传递数据
      type: Boolean,
      default: () => false
    },
    stripe: { // 是否为斑马纹
      type: Boolean,
      default: () => false
    },
    verifyRemark: { // 是否展示操作列
      type: Boolean,
      default: false
    },
    defaultSort: { // 默认排序
      type: Object,
      default: () => { }
    },
    rowClassName: {
      type: Function,
      default: () => { }
    },
    lazy: { // 树形结构异步加载
      type: Boolean,
      default: false
    },
    rowKey: { // 指定唯一key
      type: String,
      default: 'id'
    },
    treeProps: { // 树形表格配置
      type: Object,
      default: () => { }
    },
    loade: { // 展开子节点时触发
      type: Function,
      default: () => { }
    },
    rowStyle: { // 行样式
      type: [Object, Function],
      default: () => { }
    },
    config: {
      type: Object,
      default: () => { return {} }
    },
    single: {
      type: Boolean,
      default: false
    },
    needPage: {
      type: Boolean,
      default: true
    },
    popover: {
      type: Boolean,
      default: true
    },
    verifyWidth: {
      type: Number,
      default: 100
    },
    height: 0,
    nulltext: {
      type: String,
      default: '暂无数据'
    }
  },
  components: {
  },
  data() {
    return {
      selectData: [],
      head: [],
      ruleForm: {
        pagData: {
          // 分页参数
          page: 1, // 页码
          pageSizes: [30, 50, 100], // 每页条数类型
          number: 30, // 每页显示条数
          layout: "prev, pager, next, sizes, jumper, total", // 布局
          total: 0 // 总页数
        }
      },
      tableList: [],
      loading: true,
      requestData: [],
      parentDepartmentList: false,
      nowHeight: 0,
    }
  },
  watch: {
    tableList: {
      handler() {
        this.$refs.multipleTable ? this.$refs.multipleTable.bodyWrapper.scrollTop = 0 : ''
      },
      deep: true
    },

  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    init(head) {
      this.head = require(`@/const/${head || this.tableHead}`).list // 获取表头
    },
    clearData() { // 清空数据
      this.selectData = [];
      this.$refs.multipleTable.clearSelection();
    },
    handleSizeChange(data) { // 每页数据条数改变时
      this.ruleForm.pagData.number = data;
      if (this.isSelfMak) {
        this.selfHandleSizeChange(data)
      } else {
        this.getTableList();
      }
    },
    handleCurrentChange(data) { // 页数改变
      this.ruleForm.pagData.page = data;
      if (this.isSelfMak) {
        this.selfHandleCurrentChange(data)
      } else {
        this.getTableList();
      }
    },
    async handleSelectionChange(val) { // 勾选多选
      // console.log(val, this.selectData, this.rowKey, 111)
      let differenceArr = [] // 差集
      let isChos = true // 是否勾选
      if (val.length > this.selectData.length) {
        // 选择的多于已选，证明是添加了的，所以求选择之于已选的差集，并勾选
        differenceArr = this.selectData.length ? val.filter(itemA =>
          !this.selectData.some(itemB =>
            itemA[this.rowKey] === itemB[this.rowKey]
          )
        ) : val

        // 将差集push到已选择的对象数组里面，再去重
        this.selectData.push(...differenceArr)
        let uniqueIds = {}
        this.selectData = this.selectData.filter(item => {
          if (!uniqueIds[item[this.rowKey]]) {
            uniqueIds[item[this.rowKey]] = true
            return true
          }
          return false
        })

      } else if (val.length <= this.selectData.length) {
        // 选择的少于已选，证明是减少了的，所以求已选之于选择的差集，并取消勾选
        differenceArr = this.selectData.length ?
        this.selectData.filter(itemA => !val.some(itemB => itemA[this.rowKey] === itemB[this.rowKey]))
          :
        val
        isChos = false

        // 将差集从已选的数组中去除
        this.selectData = this.selectData.filter(itemA => !differenceArr.some(itemB => itemA[this.rowKey] === itemB[this.rowKey]))
      }

      // console.log(differenceArr, isChos, 11111)
      // 判断有没有子集，如果有，子集也需要勾上
      for (let i = 0, len = differenceArr.length; i < len; i++) {
        await this.treeFn(differenceArr[i], isChos)
      }


      // this.selectData = differenceArr
      // console.log(this.selectData, 111)
      this.$emit('handleSelectionChange', this.selectData)
    },
    treeFn(data, bol) {
      if (!data.children || !data.children.length) return
      for (let i = 0, len = data.children.length; i < len; i++) {
        this.$refs.multipleTable.toggleRowSelection(data.children[i], bol)
        if (data.children[i].children.length) {
          this.treeFn(data.children[i], bol)
        }
      }
    },
    selfHandleSizeChange(data) {
      this.ruleForm.pagData.page = 1
      if (this.requestData.length < data) {
        this.tableList = JSON.parse(JSON.stringify(this.requestData))
      } else {
        this.tableList = this.requestData.slice(0, data)
      }
    },
    selfHandleCurrentChange(data) {
      if (data > 1) {
        this.tableList = this.requestData.slice(this.ruleForm.pagData.number * (data - 1), this.ruleForm.pagData.number * (data - 1) + this.ruleForm.pagData.number)
      } else {
        this.tableList = this.requestData.slice(0, this.ruleForm.pagData.number)
      }
      this.ruleForm.pagData.page = data;
    },
    initQuery() {
      this.ruleForm.pagData.page = 1
      return this.getTableList()
    },
    getTableList() { // 获取数据
      if (this.isSelfMak) {
        this.selfPageSplit(this.dataset)
        return
      }
      this.loading = true
      return new Promise((resolve, reject) => {
        let api
        if (this.apiUrl.url.indexOf('/') > -1) {
          api = require(`@/services/api/${this.apiUrl.url}`).default
        } else {
          api = require(`@/services/api/${this.apiUrl.url}/${this.apiUrl.url}`).default
        }
        let pageData = {
          page: this.ruleForm.pagData.page,
          number: this.ruleForm.pagData.number
        }
        if (this.config.page) {
          delete pageData.number
          pageData[this.config.page] = this.ruleForm.pagData.number
        }
        let params = Object.assign({}, pageData, this.params)
        api[this.apiUrl.methods](params).then((res) => {
          this.loading = false
          if (res.data) {
            res.data.forEach(res => res.visible = false)
            this.ruleForm.pagData.page = res.current_page;
            this.ruleForm.pagData.total = res.total;
            if (res.data && res.data.length > 0) {
              this.tableList = JSON.parse(JSON.stringify(res.data))
            } else {
              this.tableList = []
            }
          } else {
            this.selfPageSplit(res)
          }
          resolve(res)
        }).catch((err) => {
          reject(err)
          this.loading = false
        })
      })
    },
    selfPageSplit(res) {
      this.ruleForm.pagData.page = 1
      this.ruleForm.pagData.total = res.length;
      this.requestData = JSON.parse(JSON.stringify(res))
      if (res.length < this.ruleForm.pagData.number) {
        this.tableList = JSON.parse(JSON.stringify(res))
      } else {
        this.tableList = [...res.slice(0, this.ruleForm.pagData.number)]
      }
      this.loading = false
    },
    getSummaries(param) { // 统计
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总数：';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev * 1000 + curr * 1000) / 1000;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    load(tree, treeNode, resolve) {
      this.loade(tree, treeNode, resolve)
      // this.$emit(tree, treeNode, resolve)
    },
    getTableRefs() {
      return this.$refs.multipleTable
    },
    singleElection(row) {
      this.$emit('selectSingle', row)
    },
    getValueByPath(obj, path) {
      // 分割路径并去除最后一个元素
      const paths = path.split('.');
      const lastPart = paths.pop();

      // 遍历路径，深入到对象的指定层级
      let tempObj = obj;
      for (let i = 0; i < paths.length; i++) {
        tempObj = tempObj[paths[i]];
        if (tempObj === undefined || tempObj === '' || tempObj === null) return '-'; // 如果路径中的某个部分不存在，则返回 null
      }

      // 如果最后一部分对应的是数组，则将其元素连接为字符串
      if (Array.isArray(tempObj)) {
        return tempObj.map(item => item[lastPart]).join(', ');
      }
      return tempObj[lastPart] || '-';
    },
    tdStyle(data) {
      this.$emit('tdStyle', data)
    },
    showPopover(idx) {
      for(let i = 0; i < this.ruleForm.pagData.number; i++) {
        let ele = this.$refs['autoPopover_' + i]
        if(ele && idx !== i) {
          ele.doClose()
        }
      }
    }
  }
}
</script>
<style lang="scss">
.table-popover {
  border-radius: 4px;
  overflow: hidden;
}
.common-table {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  #table-box-head {
    flex-shrink: 0;
  }
  .multipleTable-box {
    height: 0;
    flex: 1;
  }
  .el-table::before {
    display: none;
  }
  .null-box {
    .wf-button {
      width: 200px;
    }
  }
  .single-style {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-radio__label {
      display: none;
    }
  }
  // .el-table__header-wrapper {
  //   th > .cell {
  //     padding-left: 17px;
  //   }
  //   th {
  //     border-bottom: 0 none !important;
  //   }
  // }
  .finish .cell-table-item {
    opacity: 0.2;
  }

  .load-more {
    &:hover {
      color: #409eff;
      cursor: pointer;
    }
  }
  .el-table {
    // border: 0 none;
    // background-color: #eeeff3;
    th.el-table__cell > .cell {
      padding-left: 17px;
    }
    th.el-table__cell:first-child > .cell {
      padding-left: 24px;
    }
    th.el-table-column--selection > .cell {
      padding-left: 17px !important;
    }
    thead {
      color: rgba(32, 32, 32, 0.6);
    }
  }
  // .el-table tbody tr:nth-child(2n - 1) {
  //   td {
  //     background-color: #f7f8f9;
  //   }
  // }
  .has-gutter th {
    font-size: 14px;
    padding: 12px 0;
  }
  .pagination-block {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
    background-color: #fff;
  }

  .tableBtns {
    .btnTxt {
      font-size: 12px;
      color: #409eff;
      display: inline-block;
      cursor: pointer;
      margin-right: 10px;
    }
  }
  .autoClicks {
    text-align: left;
    padding-left: 20px;
    line-height: 1;
    i {
      font-size: 14px;
    }
  }
  .el-table__header th {
    background-color: #fff !important;
  }
  .el-table__header th:first-child .cell {
    padding-left: 24px;
  }
  .el-table__header .cell {
    padding-left: 17px;
  }

  .el-table th.el-table__cell.is-leaf, .el-table td.el-table__cell {
    border-color: rgba(32,32,32,0.08);
  }
  .el-table--medium th {
    height: 35px;
    padding: 4px 0;
  }
  .el-table__fixed {
    .cell-style {
      height: 48px;
      padding: 0;
    }
  }

  .el-table__body-wrapper {
    // border-radius: 16px 16px 0 0;
    // background-color: #f8f9fb;
    // height: 100% !important;
    // border-top: 1px solid rgba(231, 232, 237, 1);
    .cell-style {
      height: 48px;
      padding: 0;
      .el-table__expand-icon,
      .el-table__placeholder {
        margin-right: -14px;
        margin-left: -8px;
        width: 24px;
      }
      .cell {
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 !important;
      }
      .cell-table-item {
        padding: 0 17px !important;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
      }
      .cell-table-item--box {
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .color-type-check {
        height: 100%;
        p {
          cursor: pointer;
          &:hover {
            i {
              color: #509aff;
            }
            color: #509aff;
          }
        }
      }
    }
    .cell-style:first-child {
      .cell-table-item {
        padding-left: 24px !important;
      }
    }
  }
  .el-table-column--selection {
    .cell {
      justify-content: center;
    }
  }
  .el-table th.is-sortable {
    &:hover {
      // background-color: rgba(32, 32, 32, 0.04) !important;
      color: #509aff;
    }
    &:active {
      // background-color: rgba(32, 32, 32, 0.08) !important;
      color: #509aff;
    }
  }
}
.title-popover {
  color: #999;
  font-size: 14px;
  padding: 6px;
}
.left-move-animate {
  min-width: 160px;
  transition: all 0.3s;
}
.btns-popover {
  padding: 8px 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  flex-direction: column;
  span {
    display: block;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 16px;
    &:hover {
      background-color: rgba(32, 32, 32, 0.04);
    }
    &:active {
      background-color: rgba(32, 32, 32, 0.08);
    }
  }
}
.el-popover {
  border: 0 none;
}
</style>
